module.exports = __webpack_public_path__ + "static/media/icon-table-help.3113ebc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-table-help.svg
// module id = 121
// module chunks = 0